exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FormVcDemo h4[data-v-c8262ecc]{color:#066}.FormVcDemo .demoItem[data-v-c8262ecc]{padding:10px 0;font-size:18px}.FormVcDemo .demoItem .vc-col[data-v-c8262ecc]{padding-left:15px}.FormVcDemo .formItem[data-v-c8262ecc]{width:100%}", ""]);

// exports
